import { Link as LinkR } from 'react-router-dom';
import styled from 'styled-components';
import _default from '../../themes/default';

export const Nav = styled.div`
    background-color: ${({theme}) => theme.card_light};
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
    position: sticky;
    top: 0;
    z-index: 10;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    @media (max-width: 640px) {
        transition: 0.8s all ease;
        background-color:${({theme}) => theme.theme};
        height: 70px;
    }
`;

export const NavbarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  z-index: 1;
  width: 100%;
  padding: 0 24px;
  max-width: 1200px;
`;

export const NavLogo = styled(LinkR)`
    width: 80%;
    padding: 0 6px;
    display: flex;
    justify-content: start;
    align-items: center;
    text-decoration: none;
    font-size: 24px;
    color: ${({ theme }) => theme.primary};
    font-weight: bold;
    @media (max-width: 640px) {
      padding: 0;
      font-size: 20px;
  }
`;

export const Span = styled.div`
    padding: 0 4px;
    font-weight: bold;
    font-size: 18px;
`;

export const NavItems = styled.ul`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 32px;
    padding: 0 6px;
    list-style: none;

    @media screen and (max-width: 768px) {
      display: none;
    }
`;

export const NavLink = styled.a`
    color: ${({ theme }) => theme.text_primary};
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    text-decoration: none;

    :hover {
      color: ${({ theme }) => theme.primary};
         text-decoration: underline;



    }

    &.active {
      border-bottom: 2px solid ${({ theme }) => theme.primary};
      text-decoration: underline;
    }
`;
export const GitHubButton = styled.a`
  border: 1.8px solid ${({ theme }) => theme.primary};
  justify-content: center;
  display: flex;
  align-items: center;
  height: 70%;

  border-radius: 20px;
  color: ${({ theme }) => theme.primary};
  cursor: pointer;
  padding-left: 20px;
  padding: 0 20px;
  font-weight: 500;
  text-decoration: none;
  font-size: 16px;
  transition: all 0.6s ease-in-out;

  :hover {
    background: ${({ theme }) => theme.primary};
    color: ${({ theme }) => theme.white};
    transform: scale(1.05);
  }

  @media screen and (max-width: 768px) {
    font-size: 14px;
    height: 40px;
    width: 100px;
    padding: 0 15px;
  }
`;
export const LinkedinButton = styled.a`
  border: 1.8px solid ${({ theme }) => theme.primary};
  justify-content: center;
  display: flex;
  align-items: center;
  height: 70%;

  border-radius: 20px;
  color: ${({ theme }) => theme.primary};
  cursor: pointer;
  padding-left: 20px;
  padding: 0 20px;
  font-weight: 500;
  text-decoration: none;
  font-size: 16px;
  transition: all 0.6s ease-in-out;

  :hover {
    background: ${({ theme }) => theme.primary};
    color: ${({ theme }) => theme.white};
    transform: scale(1.05);
  }

  @media screen and (max-width: 768px) {
    font-size: 14px;
    height: 40px;
    width: 100px;
    padding: 0 15px;
  }
`;


export const ButtonContainer = styled.div`
  width: 80%;
  height: 100%;
  display: flex;
  justify-content: end;
  align-items: center;
  padding: 0 6px;

  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const MobileIcon = styled.div`
  display: none;

  @media screen and (max-width: 768px) {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(-100%, 60%);
    font-size: 1.5rem;
    cursor: pointer;
    color: ${({ theme }) => theme.text_primary};
    transition: color 0.3s ease;

    &:hover {
      color: ${({ theme }) => theme.secondary};
    }
  }
`;

export const MobileMenu = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 16px;
    position: absolute;
    top: 70px;
    right: 0;
    width: 100%;
    padding: 12px 40px 24px 40px;
    background: ${({ theme }) => theme.card_light + 99};
    transition: all 0.6s ease-in-out;
    transform: ${({ isOpen }) => (isOpen ? 'translateY(0)' : 'translateY(-100%)')};
    border-radius: 0 0 20px 20px;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
    opacity: ${({ isOpen }) => (isOpen ? '100%' : '0')};
    z-index: ${({ isOpen }) => (isOpen ? '1000' : '-1000')};
    backdrop-filter: blur(10px); /* Adding a blur effect for a more modern look */
`;

export const MobileMenuItems = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 32px;
  list-style: none;
  width: 100%;
  height: 100%;
`;
export const MobileMenuLink = styled(LinkR)`
  color: ${({ theme }) => theme.text_primary};
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  text-decoration: none;
  padding: 8px 12px;
  border-radius: 10px;

  :hover {
    background-color: #FF8C00; /* Dark Orange */
    color: ${({ theme }) => theme.primary};
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  }

  &.active {
    background-color: #FF4500; /* Orange Red */
    color: ${({ theme }) => theme.white};
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  }
`;

export const MobileMenuButton = styled.a`
  border: 1.8px solid ${({ theme }) => theme.primary};
  justify-content: center;
  display: flex;
  align-items: center;
  height: 70%;
  border-radius: 20px;
  color: ${({ theme }) => theme.primary};
  cursor: pointer;
  padding: 0 20px;
  font-weight: 500;
  text-decoration: none;
  font-size: 16px;
  transition: all 0.3s ease-in-out;

  :hover {
    background-color: #32CD32; /* Lime Green */
    color: ${({ theme }) => theme.white};
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  }

  &.active {
    background-color: #228B22; /* Forest Green */
    color: ${({ theme }) => theme.white};
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  }
`;

export const MobileLink = styled.a`
  color: ${({ theme }) => theme.text_primary};
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  text-decoration: none;
  padding: 8px 12px;
  border-radius: 10px;

  :hover {
    background-color: #1E90FF; /* Dodger Blue */
    color: ${({ theme }) => theme.white};
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  }

  &.active {
    background-color: #4169E1; /* Royal Blue */
    color: ${({ theme }) => theme.white};
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  }
`;
export const MobileNavLogo = styled(LinkR)`
  width: 80%;
  padding: 0 6px;
  display: flex;
  justify-content: start;
  align-items: center;
  text-decoration: none;
  transition: all 0.3s ease-in-out;
  font-size: 24px; /* Larger font size for better visibility */

  @media (max-width: 640px) {
    padding: 0;
    font-size: 20px;
  }

  :hover {
    background-color: #FFD700; /* Gold */
    color: ${({ theme }) => theme.white};
    border-radius: 10px;
  }

  &.active {
    background-color: #FFA500; /* Orange */
    color: ${({ theme }) => theme.white};
    border-radius: 10px;
  }
`;
